module.exports = __webpack_public_path__ + "static/media/beep.18cc1032.ogg";